<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
      <div>
        <el-card class="NumberCardWidth">
          <div class="deal flex-between">
            <div class="card-text">
              <h3>改衣单记录</h3>
            </div>
            <div class="card-button">
              <el-button
                class="push-button"
                icon="iconfont icon-fanhui"
                @click="NvagetToLookMenber"
                plain
                >返回基本信息</el-button
              >
            </div>
          </div>
          <div class="NumberTable">
            <!-- table列表 -->
            <Table
              @TouchTheBottom="TouchTheBottom"
              :PagesData="paging"
              :tableData="list.tbody"
              :configTable="list.thead"
              :config="list"
            ></Table>
          </div>
        </el-card>
      </div>
      <!-- 右侧列表相关链接 -->
      <!-- 使用封装的组件 -->
      <div class="PagesContentRight">
        <RightCard></RightCard>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { GetUpdressPage } from "@/api/viewMemberModule";
import { getcpyNo } from "@/utils/auth";
import Table from "/src/components/NumberTable/index.vue";
export default {
  name: "centre",
  components: {
    Table: Table,
  },
  data() {
    return {
      paging: {
         page: 1,
        size: 50,
        total: 0,
        pages: 2,
        Loading: true,
      },
      list: {
        thead: [
          //设置表头
          {
            label: "",
            prop: "CopyIndex",
            width: 50,
          },
          {
            label: "改衣单号",
            prop: "orderNo",
            width: 200,
          },
          {
            label: "门店",
            prop: "shopName",
            width: 150,
          },
          {
            label: "销售单号",
            prop: "saleNo",
            width: 160,
          },
          {
            label: "商品条码",
            prop: "barCode",
            width: 160,
          },
          {
            label: "改衣单状态",
            prop: "stateText",
            width: 120,
          },
          {
            label: "费用类型",
            prop: "payWayText",
            width: 160,
          },
          {
            label: "修改费用",
            prop: "fee",
            width: 160,
          },
          {
            label: "修改类型",
            prop: "modifyKindText",
            width: 80,
          },
          {
            label: "修改内容",
            prop: "modifyContext",
            width: 160,
          },
          {
            label: "创建人",
            prop: "createUserName",
            width: 80,
          },
          {
            label: "创建时间",
            prop: "createTime",
            width: 160,
          },
          {
            label: "最后修改人",
            prop: "updateUserName",
            width: 160,
          },
          {
            label: "最后修改时间",
            prop: "updateTime",
            width: 200,
          },
        ],
        tbody: [],
      },
    };
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
    }),
  },
  created() {
    this.RGetUpdressPage();
  },
  methods: {
    ReturnState(key) {
      let text = "";
      switch (key) {
        case 0:
          text = "已交付";
          break;
        case 1:
          text = "待取衣";
          break;
        case 2:
          text = "修改中";
          break;
      }
      return text;
    },
    ReturnmodifyKindText(key) {
      let text = "";
      switch (key) {
        case 0:
          text = "常规修改";
          break;
        case 1:
          text = "瑕疵修改";
          break;
        case 2:
          text = "皮草修改";
          break;
        case 3:
          text = "配饰修复";
          break;
      }
      return text;
    },
    ReturnPayWay(payWay) {
      let text = "";
      switch (payWay) {
        case 0:
          text = "自费";
          break;
        case 1:
          text = "保修需报销";
          break;
        case 2:
          text = "保修无需报销";
          break;
      }
      return text;
    },
    RGetUpdressPage() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        custID: this.custID,
        pageSize: this.paging.size,
        pageNo: this.paging.page,
      });
      GetUpdressPage(data).then((res) => {
        if (res.success) {
          this.paging.total = res.data.total;
          this.paging.pages = res.data.pages;
          res.data.list.forEach((item, index) => {
            item.CopyIndex =
              (this.paging.page - 1) * this.paging.size + index + 1;
            item.payWayText = this.ReturnPayWay(parseInt(item.payWay));
            item.modifyKindText = this.ReturnmodifyKindText(parseInt(item.modifyKind));
            item.createTime = this.renderTime(item.createTime);
            item.updateTime = this.renderTime(item.updateTime);
            item.stateText = this.ReturnState(parseInt(item.state));
          });
          this.list.tbody =this.list.tbody.concat(res.data.list);
        } else {
          this.$message.error(res.message);
        }
        this.paging.Loading = false;
      });
    },
    renderTime(date) {
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    TouchTheBottom() {
      this.paging.page++;
      this.RGetUpdressPage();
    },
    NvagetToLookMenber() {
      this.$router.push("/LookMember");
    },
  },
};
</script>
<style lang="scss" scoped>
.NumberCardWidth {
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
  height: 990px;
  margin-left: 25px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.NumberTable {
  margin-top: 40px;
}
.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
  border-radius: 7px;
  color: #a19b59;
}
</style>
